import { Log } from '@o/Helper.js'

window.Log = Log

import Common from './common.js'
import './settings.js'
import './notices.js'
import './get-started.js'
import './other/widget.js'

(() => {
    Common.init()
})()